import { Label } from "@radix-ui/react-label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/UiComponents/select";
import { FieldWrapper } from "../Additional/FieldWrapper";

export interface SelectOption {
  value: string;
  label: string;
}

interface CustomSelectProps {
  label?: string;
  options?: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: string;
  labelClassName?: string;
  required?: boolean;
  disabled?: boolean;
  name: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  options = [], // Default empty array
  value,
  onChange,
  placeholder = "Select",
  required = false,
  disabled = false,
  name,
}) => {
  const safeOptions = Array.isArray(options) ? options : [];
  return (
    <div className="">
      {label && (
        <Label className={"block text-sm font-medium mb-2"}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </Label>
      )}
      <FieldWrapper name={name}>
        <Select
          value={value}
          onValueChange={onChange}
          disabled={disabled}
        >
          <SelectTrigger className={"w-[180px]"}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {safeOptions.map((option: SelectOption) => (
              <SelectItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FieldWrapper>
    </div>
  );
};

export default CustomSelect;
